import calculateOrderItemsSubtotal from "./calculateOrderItemsSubtotal"
import calculateTaxesAndCharges from "./calculateTaxesAndCharges"
import calculateTotalDeliveryFee from "./calculateTotalDeliveryFee"
import calculateTotalFoodDiscounts from "./calculateTotalFoodDiscounts"
import onlyPositiveNumber from "./onlyPositiveNumber"
import roundNumber from "./roundNumber"

const getCheckoutPaymentInfo = (
  orderItems,
  orderCombos,
  discounts,
  deliveryFees,
  deliveryType
) => {
  const {
    totalDeliveryFee,
    totalDeliveryFeeBeforeDiscount,
    totalDeliveryDiscountByCoupon
  } =
    calculateTotalDeliveryFee(
      discounts,
      deliveryFees,
      deliveryType
    )

  const totalComboDiscounts =
    orderCombos.reduce((t, combo) =>
      t += combo.comboDiscount
      , 0
    )

  const orderItemsSubTotal =
    calculateOrderItemsSubtotal(orderItems)

  const subTotalComboItems =
    orderCombos.reduce((t, combo) =>
      t +=
      combo.items.reduce((to, item) =>
        to += item.salePrice * item.quantity
        , 0
      )
      , 0
    )

  const totalSystemDiscounts =
    orderItems.reduce((to, item) =>
      to += (item.systemDiscount > 0 ? item.systemDiscount : 0) * item.quantity
      , 0
    )

  const subtotal =
    orderItemsSubTotal +
    subTotalComboItems

  const totalFoodCouponDiscount =
    calculateTotalFoodDiscounts(discounts)

  const totalFoodDiscounts =
    totalComboDiscounts +
    totalSystemDiscounts +
    totalFoodCouponDiscount

  const totalDiscount =
    totalFoodDiscounts +
    totalDeliveryDiscountByCoupon

  const taxesAndCharges =
    calculateTaxesAndCharges(
      orderCombos,
      orderItems,
      deliveryFees,
      discounts,
      deliveryType
    )

  const totalTax =
    taxesAndCharges.reduce((t, tax) =>
      t += !tax.isNotTax ? tax.amount : 0,
      0
    )

  const totalCharges =
    taxesAndCharges.reduce((t, charge) =>
      t += charge.isNotTax ? charge.amount : 0
      , 0
    )

  const totalWithouRounding =
    onlyPositiveNumber(
      subtotal +
      totalTax +
      totalCharges +
      totalDeliveryFee -
      totalDiscount
    )

  const total =
    roundNumber(
      totalWithouRounding
    )

  return {
    total,
    subtotal,
    totalTax,
    totalCharges,
    totalDiscount,
    taxesAndCharges,
    totalFoodDiscounts,
    totalFoodCouponDiscount,
    totalSystemDiscounts,
    totalDeliveryDiscountByCoupon,
    totalDeliveryFeeBeforeDiscount
  }
}

export default getCheckoutPaymentInfo